export default "__VITE_ASSET__4ab35795__"